// Shared rules for experience cards that navigate as a whole when clicked.
//
// Rather than wiring a handler onto every clickable region, the card puts one
// handler on its root and lets clicks bubble. These are the elements that own
// their own click and must not also trigger the card navigation. Swiper's
// arrows and pagination bullets are plain divs, so they need explicit
// selectors; `.no-card-nav` is the manual escape hatch for anything else.
export const CARD_NON_NAVIGABLE_SELECTOR = [
  "a",
  "button",
  '[role="button"]',
  "input",
  "textarea",
  "select",
  ".swiper-button-prev",
  ".swiper-button-next",
  ".swiper-pagination",
  ".no-card-nav"
].join(", ")

/**
 * Whether a click that bubbled up to a card root should navigate.
 *
 * The card root is often itself a `button`, which matches the selector too, so
 * a bare `closest()` would swallow every click. Only a match *inside* the card
 * counts as "something else already handled this".
 */
export const shouldNavigateFromCardClick = (event) => {
  if (event.defaultPrevented) return false
  const interactiveTarget = event.target.closest(CARD_NON_NAVIGABLE_SELECTOR)
  return !interactiveTarget || interactiveTarget === event.currentTarget
}
